import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import TagsInput from 'react-tagsinput';
import 'react-tagsinput/react-tagsinput.css';
import { Radio, Space, Collapse, Toast, Modal, Input, Picker, SpinLoading } from 'antd-mobile'

import Lottie from 'react-lottie';
import generatingPost from '../lotties/magic_wand.json';

// Motion
import { motion } from 'framer-motion';

import {
    Avatar,
    Banner,
    Card,
    CustomSelectOption,
    FormItem,
    Textarea,
    Button,
    IconButton,
    ButtonGroup,
    Checkbox,
    ModalRoot,
    ModalPage,
    ModalPageHeader,
    PanelHeaderClose,
    PlatformProvider,
    Link,
    Slider,
    Group,
    Counter,
    Switch,
    Panel,
    SimpleCell,
    Snackbar,
    Div,
    Tabs,
    Select,
    Spacing,
    Separator,
    TabsItem,
    HorizontalScroll,
    Platform,
    Skeleton,
    SegmentedControl,
    usePlatform
} from '@vkontakte/vkui';
import { Icon28RobotOutline, Icon24RobotOutline, Icon20RadioOff, Icon20RadioOn, Icon24Squareshape4VerticalLeftOutline, Icon28InfoCircle, Icon24ClockCircleDashedOutline, Icon24ExternalLinkOutline, Icon28ErrorCircleOutline, Icon28CheckCircleOutline, Icon20HelpOutline, Icon24HomeOutline, Icon24Add, Icon24Write, Icon24Delete, Icon20BookSpreadOutline, Icon20TextBoldOutline, Icon20TextItalicOutline, Icon20Chain, Icon16ClockOutline, Icon24HelpOutline } from '@vkontakte/icons';
import DOMPurify from 'dompurify';

const tg = window.Telegram.WebApp;

const ChannelPage = ({ userInfo, FaTelegram, baseTheme, avatarSrc, isMobile, setGptLink, setGptMedia, setGptText, selectedGroup, activeView, setActiveView, premodePosts }) => {
    const [s_tags, s_setTags] = useState([]);
    const [s_currentTag, s_setCurrentTag] = useState('');
    const [n_tags, n_setTags] = useState([]);
    const [n_currentTag, n_setCurrentTag] = useState('');
    const [k_tags, k_setTags] = useState([]);
    const [k_currentTag, k_setCurrentTag] = useState('');
    const [t_tags, t_setTags] = useState([]);
    const [t_currentTag, t_setCurrentTag] = useState('');
    const [prompt_input, set_PromptInput] = useState('Напиши пост для на основе этого текста. Сохрани все важные детали из исходного текста. Пиши от первого лица. Расставь по тексту эмодзи. Разбивай текст на абзацы. Придумай для поста заголовок и оберни его в <b> </b>\n\nВ конце поста отступи абзац и поставь хештег на тему поста');
    const [sign, setSign] = useState('');
    const s_inputRef = useRef(null);
    const k_inputRef = useRef(null);
    const n_inputRef = useRef(null);
    const t_inputRef = useRef(null);
    const textRef = useRef(null);
    const rangeRef = useRef(null);
    const [isBold, setIsBold] = useState(false);
    const [isItalic, setIsItalic] = useState(false);
    const [url, setUrl] = useState('');
    const [saveState, setSaveState] = useState(false);
    const [loadingState, setLoadingState] = useState(true);
    const [newStreamName, setNewStreamName] = useState('');
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [renameStreamModal, setRenameStreamModal] = useState(false);
    const [savedSelection, setSavedSelection] = useState(null);
    // const [isUnderline, setIsUnderline] = useState(false);
    // const [isStrikeThrough, setIsStrikeThrough] = useState(false);
    const [isLink, setIsLink] = useState(false);
    const [isClearingInputS, setIsClearingInputS] = useState(false);
    const [isClearingInputK, setIsClearingInputK] = useState(false);
    const [isClearingInputN, setIsClearingInputN] = useState(false);
    const [isClearingInputT, setIsClearingInputT] = useState(false);
    const [loading, setLoading] = useState(false);
    const MODAL_PAGE_WITH_FIXED_HEIGHT = 'fixed-height';
    const sources_modal = 'sources';
    const keywords_modal = 'keywords';
    const negative_modal = 'negative';
    const source_modal = 'source';
    const force_modal = 'force';
    const media_modal = 'media';
    const original_modal = 'original'
    const prompt_modal = 'prompt';
    const temp_modal = 'temp';
    const timer_modal = 'timer';
    const days_modal = 'days';
    const [styleType, setStyleType] = useState('lead');
    const [activeModal, setActiveModal] = useState(null);
    const [modalHistory, setModalHistory] = useState([]);
    const [testSummary, setTestSummary] = useState("");
    const [testTitle, setTestTitle] = useState("");
    const [testImage, setTestImage] = useState([]);
    const [testLink, setTestLink] = useState("");
    const [gptTemp, setGptTemp] = useState(0);
    const [shift, setShift] = useState(0);
    const [premodeTime, setPremodeTime] = useState(15);
    const [postSettings, setPostSettings] = useState('prompt');
    const [isAutoPostingEnabled, setIsAutoPostingEnabled] = useState();
    const [isGroupAdd, setIsGroupAdd] = useState();
    const [isPremodeEnabled, setIsPremodeEnabled] = useState(false);
    const [days, setDays] = useState(['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']);
    const [postOriginal, setPostOriginal] = useState();
    const [postSource, setPostSource] = useState();
    const [postForce, setPostForce] = useState();
    const [postMedia, setPostMedia] = useState();
    const [text, setText] = React.useState('');
    const [themes, setThemes] = useState([]);
    const [prevThemeSources, setPrevThemeSources] = useState([]);
    const [theme, setTheme] = useState(null);
    const [prompts, setPrompts] = useState([]);
    const [promptLibrary, setPromptLibrary] = useState(null);
    const [snackbar, setSnackbar] = React.useState(null);
    const [timeVisible, setTimeVisible] = useState(false);
    const [loadingScreen, setLoadingScreen] = useState('none');
    const [adjustedTags, setAdjustedTags] = useState([]);
    const filteredPosts = premodePosts.filter(post => selectedGroup === null || post.id === selectedGroup.id);
    const postCount = filteredPosts.length;
    const inputRef = useRef(null);
    const streamNameRef = useRef(null);
    const platform = usePlatform();

    const cursorPosition = useRef(null);

    const tg_id = window.Telegram.WebApp.initDataUnsafe.user.id
    const clearIconElement = document.querySelector('.vkuiCustomSelect--clear-icon');

    const handleZoneChange = (event) => {
        // Получаем строковое значение из события
        const stringValue = event.target.value;

        // Преобразуем строковое значение в целое число
        const intValue = parseInt(stringValue, 10);

        // Убедитесь, что значение действительно было преобразовано в число
        if (!isNaN(intValue)) {
            setShift(intValue);

            console.log(intValue);

            setTabs((currentTabs) => {
                return currentTabs.map((tab) => {
                    if (tab.id === selected) {
                        return {
                            ...tab,
                            streamData: {
                                ...tab.streamData,
                                shift: intValue,
                            },
                        };
                    }
                    return tab;
                });
            });
        } else {
            console.warn("Преобразование value в int не удалось:", stringValue);
        }
    };

    const timeZones = [
        { gmt: "GMT-12 (Бейкер)", shift: -15 },
        { gmt: "GMT-11 (Паго-Паго)", shift: -14 },
        { gmt: "GMT-10 (Гонолулу)", shift: -13 },
        { gmt: "GMT-9 (Анкоридж)", shift: -12 },
        { gmt: "GMT-8 (Лос-Анджелес)", shift: -11 },
        { gmt: "GMT-7 (Денвер)", shift: -10 },
        { gmt: "GMT-6 (Чикаго, Мехико)", shift: -9 },
        { gmt: "GMT-5 (Нью-Йорк, Богота)", shift: -8 },
        { gmt: "GMT-4 (Сантьяго, Каракас)", shift: -7 },
        { gmt: "GMT-3 (Буэнос-Айрес, Бразилиа)", shift: -6 },
        { gmt: "GMT-2 (Среднеатлантическое время)", shift: -5 },
        { gmt: "GMT-1 (Азорские острова)", shift: -4 },
        { gmt: "GMT±0 (Лондон, Дакар)", shift: -3 },
        { gmt: "GMT+1 (Париж, Берлин, Лагос)", shift: -2 },
        { gmt: "GMT+2 (Калининград, Афины, Каир)", shift: -1 },
        { gmt: "GMT+3 (Москва, Санкт-Петербург, Казань)", shift: 0 },
        { gmt: "GMT+4 (Самара, Волгоград, Дубай, Баку)", shift: 1 },
        { gmt: "GMT+5 (Екатеринбург, Уфа, Ташкент)", shift: 2 },
        { gmt: "GMT+6 (Омск, Челябинск, Алматы)", shift: 3 },
        { gmt: "GMT+7 (Новосибирск, Красноярск, Бангкок)", shift: 4 },
        { gmt: "GMT+8 (Иркутск, Улан-Удэ, Пекин)", shift: 5 },
        { gmt: "GMT+9 (Якутск, Чита, Токио, Сеул)", shift: 6 },
        { gmt: "GMT+10 (Владивосток, Хабаровск, Сидней)", shift: 7 },
        { gmt: "GMT+11 (Магадан, Сахалин)", shift: 8 },
        { gmt: "GMT+12 (Камчатка, Анадырь, Окленд)", shift: 9 },
        { gmt: "GMT+13 (Тонга, Апиа)", shift: 10 },
        { gmt: "GMT+14 (Лайн-Айлендс)", shift: 11 }
    ];

    useEffect(() => {
        // Находим все input внутри div с классом timer
        const inputs = document.querySelectorAll('div.timer input');
        inputs.forEach(input => {
            input.setAttribute('readonly', true);
        });

        // Функция очистки эффекта (опционально)
        return () => {
            inputs.forEach(input => {
                input.removeAttribute('readonly');
            });
        };

    }, []); // Пустой массив зависимостей означает выполнение эффекта только при монтировании

    const communityLink = () => {
        tg.showPopup({
            title: "Выход из сервиса",
            message: "Вы покидаете сервис и переходите в Telegram-чат коммьюнити GiveMePublic. Там можно задать любой вопрос по настройкам и/или по работе. Перейти в чат?",
            buttons: [
                { id: 'ok', text: 'Перейти' },
                { id: 'cancel', type: 'cancel' },
            ]
        }, (buttonId) => {
            if (buttonId === 'cancel') {
                console.log("Действие отменено");
            } else if (buttonId === 'ok') {
                tg.openTelegramLink('https://t.me/ask4gmp');
                tg.close();
            }
        });
    };

    tg.MainButton.text = isAutoPostingEnabled ? 'Сохранить' : 'Сохранить';
    tg.MainButton.color = "#4bb34b"

    const [mode, setMode] = React.useState('default');
    const [selected, setSelected] = React.useState('main');
    const booleanToString = (bool) => (bool ? 'true' : 'false');
    const stringToBoolean = (str) => str === 'true';

    const initialRadioValue = booleanToString(isPremodeEnabled);

    const handleRadioChange = (e) => {
        const newValue = stringToBoolean(e);
        setIsPremodeEnabled(newValue);
    };

    const [tabs, setTabs] = useState([{ id: 'main', name: 'Основная', icon: <Icon24HomeOutline /> }]);

    const generateTimeOptions = (start, end, suffix = '') => {
        const options = [];
        for (let i = start; i <= end; i++) {
            const label = i.toString().padStart(2, '0');
            options.push({ label, value: label + suffix });
        }
        return options;
    };

    const basicColumns = [
        generateTimeOptions(0, 23),
        [':'],
        generateTimeOptions(0, 59),
    ];

    const dayLabels = [
        ['Mon', 'Пн'],
        ['Tue', 'Вт'],
        ['Wed', 'Ср'],
        ['Thu', 'Чт'],
        ['Fri', 'Пт'],
        ['Sat', 'Сб'],
        ['Sun', 'Вс']
    ];

    const closeModalStyles = () => {
        setStyleType("lead");
    };

    const handleCheckboxChange = (day) => {
        // Обновление состояния days
        setDays((prevDays) =>
            prevDays.includes(day)
                ? prevDays.filter((d) => d !== day)
                : [...prevDays, day]
        );
    };

    const options = [
        { label: "10 минут", value: 10 },
        { label: "15 минут", value: 15 },
        { label: "30 минут", value: 30 },
        { label: "1 час", value: 60 },
        { label: "2 часа", value: 120 }
    ];

    const postStyles = [
        { label: "Вовлекающий", id: 0, icon: "‍🧲", type: "Подводка", typeValue: "lead", value: 'Составь увлекательную и мотивирующую подводку для социальных сетей к данной статье. Пиши в энергичном стиле. Выдели пользу, которую читатель получит от прочтения полной статьи. Используй интригующие вопросы или захватывающие факты из статьи, чтобы заинтересовать аудиторию. Обращайся напрямую к читателю, создавая ощущение личного обращения. Дели текст на короткие абзацы для удобства восприятия. В конце подводки добавь деликатный призыв к действию: перейти на сайт и прочитать статью целиком. ' },
        {
            label: "Новостной", id: 1, icon: "‍📑", type: "Подводка", typeValue: "lead", value: 'Составь подводку для социальных сетей к данной статье, чтобы мотивировать читателя перейти на сайт и прочитать новость целиком.\n' +
                '\n' +
                'Пиши в классическом новостном стиле. Придумай заголовок и обозначь его тэгами <b> и </b>.\n' +
                '\n' +
                'Кратко изложи суть статьи, выделяя ключевые факты и события.\n' +
                'Задавай интригующие вопросы, которые заставят читателя захотеть узнать больше.\n' +
                'Используй факты из текста, чтобы показать необходимость ознакомиться с данной новостью.\n' +
                'Дели текст на короткие абзацы для удобства восприятия.\n' +
                'В конце подводки мотивируй подписчика прочитать полную статью на сайте.'
        },
        {
            label: "Развлекательный", id: 2, icon: "‍😄", type: "Подводка", typeValue: "lead", value: 'Составь развлекательный текст для социальных сетей на основе данной статьи, чтобы поднять настроение читателю.\n' +
                '\n' +
                'Пиши в лёгком и непринуждённом стиле.\n' +
                '\n' +
                'Используй иронию, чтобы подшутить над ситуацией или темой статьи.\n' +
                '\n' +
                'Применяй каламбуры для создания неожиданных ассоциаций.\n' +
                '\n' +
                'Применяй гиперболы, чтобы сделать ситуацию ярче.\n' +
                '\n' +
                'Добавляй самоиронию и лёгкие насмешки, чтобы текст казался дружеским и непринуждённым.\n' +
                'Дели текст на короткие абзацы для удобства восприятия.\n' +
                'В конце текста предложи подписчику перейти на сайт и прочитать статью целиком, используя стилистически неожиданный поворот, который нарушит ожидания подписчика.'
        },
        {
            label: "Информационный", id: 3, icon: "‍📣", type: "Подводка", typeValue: "lead", value: 'Заголовок: начни с краткого и информативного заголовка, который отражает основную суть новости.\n' +
                'Оберни заголовок тегами <b> и </b>. \n' +
                '\n' +
                'Первый абзац: представь краткое резюме главного события или информации, включая ключевые детали: кто, что, где и когда.\n' +
                '\n' +
                'Второй абзац: Предоставь дополнительные подробности или контекст, такие как источники информации или предыстория события.\n' +
                '\n' +
                'Третий абзац: Добавь другую важную информацию из первоисточника, например, важные детали или планы.\n' +
                '\n' +
                'Стиль письма: Используй нейтральный язык, характерный для новостных сообщений в деловых СМИ.\n' +
                '\n' +
                'Структура: Соблюдай общую структуру и форматирование образца, включая разделение на абзацы.\n' +
                '\n' +
                'В конце поста отступи строку и предложи перейти на сайт, чтобы прочитать и другие новости.'
        },
        {
            label: "Вовлекающий", id: 4, icon: "‍🧲", type: "Самостоятельный", typeValue: "post", value: 'Перескажи статью так, чтобы максимально вовлечь читателей и вызвать у них активную реакцию.\n' +
                'Пиши в увлекательном и энергичном стиле от первого лица.\n' +
                'Используй яркие примеры из мировой истории и риторические вопросы, чтобы заинтересовать аудиторию.\n' +
                'Обращайся напрямую к читателю, создавая ощущение диалога.\n' +
                'Дели текст на короткие, насыщенные абзацы для удобства чтения.\n' +
                'В конце текста задай провокационный вопрос или призыв к действию, чтобы побудить читателей оставить комментарий или поделиться своими мыслями.'
        },
        {
            label: "Новостной", id: 5, icon: "‍📑", type: "Самостоятельный", typeValue: "post", value: 'Составь информационный пост для социальных сетей на основе данной статьи.\n' +
                '\n' +
                'Пиши в классическом новостном стиле. Придумай заголовок и обозначь его тэгами <b> и </b>.\n' +
                '\n' +
                'Чётко и ясно изложи суть статьи, используя факты, ключевые данные и основные события.\n' +
                '\n' +
                'Подчеркни важные моменты, даты и цифры, чтобы читатель получил полное представление о теме.\n' +
                '\n' +
                'Избегай личных мнений и оценочных суждений — только факты и проверенная информация.\n' +
                '\n' +
                'Дели текст на короткие абзацы для удобства восприятия, чтобы пост выглядел логично и структурировано.'
        },
        {
            label: "Развлекательный", id: 6, icon: "‍😄", type: "Самостоятельный", typeValue: "post", value: 'Составь развлекательный текст для социальных сетей на основе данной статьи, чтобы поднять настроение читателю.\n' +
                '\n' +
                'Опирайся на факты из первоисточника. Пиши легко и непринуждённо.\n' +
                '\n' +
                'Используй яркие метафоры и неожиданную игру слов, чтобы сделать текст динамичным.\n' +
                '\n' +
                'Применяй самоиронию и лёгкий абсурд, чтобы вызвать улыбку.\n' +
                '\n' +
                'Обращайся к читателю уважительно, создавая ощущение дружеской беседы.\n' +
                '\n' +
                'Делай акцент на смешных и позитивных аспектах темы.\n' +
                '\n' +
                'Дели текст на короткие абзацы и используй риторические вопросы, чтобы поддерживать интерес читателя к теме. \n' +
                '\n' +
                'Текст должен быть завершённым и самостоятельным, не требуя чтения первоисточника.'
        },
        {
            label: "Информационный", id: 7, icon: "‍📣", type: "Самостоятельный", typeValue: "post", value: 'Заголовок: начни с краткого и информативного заголовка, который отражает основную суть новости.\n' +
                'Оберни заголовок тегами <b> и </b>. \n' +
                '\n' +
                'Первый абзац: представь краткое резюме главного события или информации, включая ключевые детали: кто, что, где и когда.\n' +
                '\n' +
                'Второй абзац: Предоставь дополнительные подробности или контекст, такие как источники информации или предыстория события.\n' +
                '\n' +
                'Третий абзац: Добавь другую важную информацию из первоисточника, например, важные детали или планы.\n' +
                '\n' +
                'Стиль письма: Используй нейтральный язык, характерный для новостных сообщений в деловых СМИ.\n' +
                '\n' +
                'Структура: Соблюдай общую структуру и форматирование образца, включая разделение на абзацы.'
        },
    ];

    const handleStyleChange = (value) => {
        setStyleType(value);
        const leadElements = document.querySelectorAll('.styleElement_lead');
        const postElements = document.querySelectorAll('.styleElement_post');

        if (value === 'lead') {
            leadElements.forEach(el => el.style.display = 'block');
            postElements.forEach(el => el.style.display = 'none');
        } else {
            leadElements.forEach(el => el.style.display = 'none');
            postElements.forEach(el => el.style.display = 'block');
        }
    };


    const handlePostChange = (e: ChangeEvent<HTMLSelectElement>) => {
        console.log('Тема:', e);
        const promptID = e.id;
        console.log('PromptID:', promptID);
        const selectPrompt = prompts[promptID]
        console.log('SelectPrompt:', selectPrompt)
        setPromptLibrary(promptID);

        Toast.show({
            icon: 'success',
            content: `Шаблон установлен:\n${selectPrompt.name}`,
        })

        // Обновляем локальное состояние для отображения в UI
        set_PromptInput(selectPrompt.prompt);

        // Обновляем общее состояние для текущей активной вкладки с новым текстом
        setTabs((currentTabs) => {
            return currentTabs.map(tab => {
                if (tab.id === selected) {
                    return {
                        ...tab,
                        // Обновляем свойство промпта в данных вкладки
                        // Вам нужно будет адаптировать путь в объекте под вашу структуру
                        // Например, если промпт является частью streamData
                        streamData: {
                            ...tab.streamData,
                            prompt: selectPrompt.prompt,
                            promptLibrary: promptID
                        },
                    };
                }
                return tab;
            });
        });
    };

    useEffect(() => {
        const backButtonHandler = () => {
            tg.HapticFeedback.impactOccurred('heavy');
            tg.HapticFeedback.notificationOccurred("success");
            setActiveView('view1');
            tg.BackButton.offClick(backButtonHandler);
        };

        // Устанавливаем обработчик нажатия на кнопку "Назад" только если activeView равен 'view1'
        if (activeView === 'channels_view') {
            tg.BackButton.show();
            // tg.MainButton.show();
            tg.BackButton.onClick(backButtonHandler);
        } else {
            tg.BackButton.offClick(backButtonHandler); // Удаляем обработчик, если activeView не 'view1'
        }

        // Очистка эффекта
        return () => {
            tg.BackButton.offClick(backButtonHandler);
        };
    }, [activeView]);

    // Функция для обновления премиум времени
    const handlePremodeChange = (e: ChangeEvent<HTMLSelectElement>) => {
        setPremodeTime(Number(e.target.value)); // Преобразование значения в число
    };

    useEffect(() => {
        // Использование актуального состояния days в функции setTabs
        setTabs((currentTabs) => {
            return currentTabs.map(tab => {
                if (tab.id === selected) {
                    return {
                        ...tab,
                        streamData: {
                            ...tab.streamData,
                            days: days, // Используем актуальное состояние days
                        },
                    };
                }
                return tab;
            })
        });
    }, [days]);

    const selectTab = (id) => {
        setSelected(id); // Устанавливаем выбранный id

        // Находим вкладку по id
        const tab = tabs.find(tab => tab.id === id);

        console.log(tab)

        // Проверяем, найдена ли вкладка; если да, показываем её name, иначе сообщаем об ошибке
        if (tab) {
            s_setTags(tab.streamData.sources || []);
            k_setTags(tab.streamData.keywords || []);
            n_setTags(tab.streamData.negative || []);
            t_setTags(tab.streamData.timer || []);
            set_PromptInput(tab.streamData.prompt || 'Сделай пересказ текста. Сохрани все важные детали из исходного текста.');
            setSign(tab.streamData.sign || '');
            setGptTemp(tab.streamData.temp || 0.5);
            setPostOriginal(tab.streamData.original || false);
            setPostSource(tab.streamData.source || false);
            setPostForce(tab.streamData.force || false);
            setPostMedia(tab.streamData.media || false);
            setDays(tab.streamData.days || ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']);
            setTheme(tab.streamData.theme || '');
            setPromptLibrary(tab.streamData.promptLibrary || '');
            setShift(tab.streamData.shift || 0)

            if (textRef.current) {
                textRef.current.innerHTML = tab.streamData.sign || '';
                checkIfEmpty(); // Проверяем, пуст ли элемент
            }
        } else {
            console.error("Ой, что-то пошло не так :(");
        }
    };

    const addTab = () => {
        // Функция для определения следующего уникального индекса
        const getNextTabIndex = () => {
            // Извлекаем числовые идентификаторы со 2-го элемента, игнорируя первый
            const indices = tabs
                .slice(1) // Исключаем первый элемент
                .map(tab => typeof tab.id === 'number' ? tab.id : 0); // Извлекаем числовые ID

            // Находим максимальное значение и возвращаем на единицу большее
            return Math.max(...indices, 0) + 1;
        };

        const newTabIndex = getNextTabIndex();
        const newTabId = newTabIndex; // Используем сам индекс как ID, если ID — это число
        const newTabName = `Рубрика ${newTabIndex}`;

        s_setTags(tabs[0]?.streamData?.sources || [], []);
        k_setTags(tabs[0]?.streamData?.keywords || [], []);
        n_setTags(tabs[0]?.streamData?.negative || [], []);
        t_setTags([]);
        set_PromptInput(tabs[0]?.streamData?.prompt || 'Сделай пересказ текста. Сохрани все важные детали из исходного текста.');
        setSign(tabs[0]?.streamData?.sign || '');
        setGptTemp(tabs[0]?.streamData?.temp || 0.5);
        setPostOriginal(tabs[0]?.streamData?.original || false);
        setPostSource(tabs[0]?.streamData?.source || false);
        setPostForce(tabs[0]?.streamData?.force || false);
        setPostMedia(tabs[0]?.streamData?.media || false);
        setDays(['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']);
        setTheme(tabs[0]?.streamData?.theme || '');
        setPromptLibrary(tabs[0]?.streamData?.promptLibrary || '');
        setShift(tabs[0]?.streamData?.shift || 0);

        const newTab = {
            id: newTabId,
            name: newTabName,
            streamData: {
                name: newTabName,
                sources: tabs[0]?.streamData?.sources,
                keywords: tabs[0]?.streamData?.keywords,
                negative: tabs[0]?.streamData?.negative,
                timer: [],
                prompt: tabs[0]?.streamData?.prompt,
                sign: tabs[0]?.streamData?.sign,
                temp: tabs[0]?.streamData?.temp,
                original: tabs[0]?.streamData?.original,
                source: tabs[0]?.streamData?.source,
                force: tabs[0]?.streamData?.force,
                media: tabs[0]?.streamData?.media,
                days: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
                shift: tabs[0]?.streamData?.shift,
                theme: null,
                promptLibrary: promptLibrary
            }
        };

        if (textRef.current) {
            textRef.current.innerHTML = tabs[0]?.streamData?.sign || '';
            checkIfEmpty(); // Проверяем, пуст ли элемент
        }

        setSelected(newTabId);
        setTabs(prevTabs => [...prevTabs, newTab]); // Используйте функциональное обновление состояния
    };

    const removeTab = () => {
        // Проверяем, есть ли что удалять и не является ли текущая вкладка основной
        if (tabs.length > 1 && selected !== 'main') {
            // Создаем новый список вкладок без текущей выбранной вкладки
            const updatedTabs = tabs.filter(tab => tab.id !== selected);
            setTabs(updatedTabs);

            // Определяем новую выбранную вкладку
            // Если удаляется первая вкладка, выбираем следующую после удаленной
            // В противном случае, выбираем предыдущую вкладку
            const currentIndex = tabs.findIndex(tab => tab.id === selected);
            const newSelectedIndex = currentIndex === 0 ? 0 : currentIndex - 1;
            setSelected(updatedTabs[newSelectedIndex].id);
            selectTab(updatedTabs[newSelectedIndex].id);
        }
    };

    const handleRenameTab = () => {
        setRenameStreamModal(true);

        setTimeout(() => {
            const element = document.querySelector('.adm-center-popup-wrap');

            console.log(element)

            if (element) {
                element.style.top = '30%';
            }
        }, 0);
    };

    const renameTab = () => {
        if (selected !== 'main') {
            // Проверяем, что пользователь ввел имя (не нажал отмену и не оставил поле пустым)
            if (newStreamName && newStreamName.trim()) {
                // Создаем копию массива вкладок
                const updatedTabs = tabs.map(tab => {
                    // Находим вкладку, которую нужно переименовать, и обновляем ее имя
                    if (tab.id === selected) {
                        return {
                            ...tab,
                            name: newStreamName.trim(),
                            streamData: {
                                ...tab.streamData,
                                name: newStreamName.trim()
                            }
                        };
                    }
                    return tab;
                });
                // Обновляем состояние вкладок
                setTabs(updatedTabs);
            }
            // Закрываем модальный диалог в любом случае
            setRenameStreamModal(false);
        }
    };

    const sourceTrue = () => {
        setSnackbar(
            <Snackbar
                onClose={() => setSnackbar(null)}
                before={<Icon28InfoCircle />}
            >
                В режиме переноса исходного текста «Промпт» и «Креативность» отключены
            </Snackbar>,
        );
    };

    const openSave = () => {
        setSnackbar(
            <Snackbar
                onClose={() => setSnackbar(null)}
                before={<Icon28CheckCircleOutline fill="var(--vkui--color_icon_positive)" />}
            >
                Изменения успешно сохранены
            </Snackbar>,
        );
    };

    const openErrorSave = () => {
        setSnackbar(
            <Snackbar
                onClose={() => setSnackbar(null)}
                before={<Icon28ErrorCircleOutline fill="var(--vkui--color_icon_negative)" />}
            >
                Произошла ошибка, попробуйте ещё раз.
            </Snackbar>,
        );
    };

    const openErrorTg = () => {
        setSnackbar(
            <Snackbar
                onClose={() => setSnackbar(null)}
                before={<Icon28ErrorCircleOutline fill="var(--vkui--color_icon_negative)" />}
            >
                Ссылки-приглашения Telegram не могут быть источником
            </Snackbar>,
        );
    };

    const openError = (fieldName) => {
        setSnackbar(
            <Snackbar
                onClose={() => setSnackbar(null)}
                before={<Icon28ErrorCircleOutline fill="var(--vkui--color_icon_negative)" />}
            >
                {`Заполните ${fieldName}`}
            </Snackbar>,
        );
    };

    const openErrorGPT = () => {
        setSnackbar(
            <Snackbar
                onClose={() => setSnackbar(null)}
                before={<Icon28ErrorCircleOutline fill="var(--vkui--color_icon_negative)" />}
            >
                Не найдена подходящая статья, попробуйте изменить источники и/или ключевые слова
            </Snackbar>,
        );
    };

    useEffect(() => {
        const getGroupData = async () => {
            try {
                const response = await axios.get(`https://api.gmpapp.ru/get_groups_p?group_id=${selectedGroup.id}`);
                const groupData = response.data;

                const fieldMapping = {
                    sources: s_setTags,
                    keywords: k_setTags,
                    negative: n_setTags,
                    timer: t_setTags,
                    prompt: set_PromptInput,
                    sign: (value) => {
                        // Use direct DOM manipulation instead of state
                        setSign(value)
                        textRef.current.innerHTML = value;
                    },
                    temp: setGptTemp,
                    active: setIsAutoPostingEnabled,
                    add: setIsGroupAdd,
                    premode: setIsPremodeEnabled,
                    premode_time: setPremodeTime,
                    original: setPostOriginal,
                    source: setPostSource,
                    force: setPostForce,
                    media: setPostMedia,
                    theme: setTheme,
                    promptLibrary: setPromptLibrary,
                    days: setDays,
                    shift: setShift
                };

                const mainStream = {};
                Object.keys(fieldMapping).forEach(fieldKey => {
                    if (groupData[fieldKey]) {
                        mainStream[fieldKey] = groupData[fieldKey];
                        fieldMapping[fieldKey](groupData[fieldKey]);
                    }
                });

                // Если значение "add" равно false, установить "active" в true
                if (!groupData.add) {
                    setIsAutoPostingEnabled(true);
                }

                setTabs(prevTabs => {
                    // Первоначально обновляем имя для вкладки с id 'main'
                    let updated = prevTabs.map(tab =>
                        tab.id === 'main' ? { ...tab, streamData: mainStream } : tab
                    );

                    // Теперь добавляем новые вкладки из groupData.streams
                    if (groupData.streams && groupData.streams.length > 0) {
                        groupData.streams.forEach(stream => {
                            updated.push({
                                id: stream.id,
                                name: stream.name,
                                streamData: stream
                            });
                        });
                    }

                    return updated; // Возвращаем новый массив вкладок
                });

                getThemes();
                getPrompts();
                setLoadingState(false);

            } catch (error) {
                console.log('Ошибка при получении данных:', error);
            }
        };

        const getThemes = async () => {
            try {
                const response = await axios.get('https://api.gmpapp.ru/get_themes');
                const themesData = response.data;
                setThemes(themesData);
                console.log('Темы:', themes)
            } catch (error) {
                console.log('Ошибка при получении тем:', error);
            }
        };

        const getPrompts = async () => {
            try {
                const response = await axios.get('https://api.gmpapp.ru/get_prompts');
                const promptsData = response.data;
                setPrompts(promptsData);
                console.log('Промпты:', themes)
            } catch (error) {
                console.log('Ошибка при получении промптов:', error);
            }
        };

        getGroupData();
    }, []);

    useEffect(() => {
        if (textRef.current && cursorPosition.current) {
            restoreSelection();
        }
    }, [textRef.current]);

    const setFocusAndStyle = () => {
        textRef.current.focus();
        checkCurrentStyle();
    };

    useEffect(() => {
        const adjustTimeWithShift = (timeArray, shift) => {
            return timeArray.map(timeString => {
                const [hours, minutes] = timeString.split(':').map(Number);
                const newHours = (hours + shift + 24) % 24; // Добавляем 24 и используем модуль, чтобы избежать отрицательных значений
                return `${String(newHours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
            });
        };

        const updateAdjustedTags = adjustTimeWithShift(t_tags, shift);
        setAdjustedTags(updateAdjustedTags);
    }, [t_tags, shift])

    const saveSelection = () => {
        if (window.getSelection) {
            const sel = window.getSelection();
            if (sel.rangeCount > 0) {
                cursorPosition.current = sel.getRangeAt(0).cloneRange();
            }
        }
    };

    useEffect(() => {
        const handleKeyPress = (e) => {
            if (textRef.current && e.key === 'Enter') {
                e.preventDefault();
                document.execCommand('insertHTML', false, '<br><br>');
            }
        };
        const textElement = textRef.current;
        textElement.addEventListener('keypress', handleKeyPress);
    }, []);

    const handleTextChange = () => {
        saveSelection()
        const cleanedHTML = cleanHTML(textRef.current.innerHTML);
        const finalSign = cleanedHTML.replace(/&nbsp;/g, ' ');
        setSign(finalSign);

        // Обновляем общее состояние для текущей активной вкладки с новым текстом
        setTabs((currentTabs) => {
            return currentTabs.map(tab => {
                if (tab.id === selected) {
                    return {
                        ...tab,
                        // Обновляем свойство промпта в данных вкладки
                        // Вам нужно будет адаптировать путь в объекте под вашу структуру
                        // Например, если промпт является частью streamData
                        streamData: {
                            ...tab.streamData,
                            sign: finalSign,
                        },
                    };
                }
                return tab;
            });
        });
    };

    const checkIfEmpty = () => {
        if (textRef.current && textRef.current.innerText.trim() === '') {
            textRef.current.classList.add('empty');
        } else {
            textRef.current.classList.remove('empty');
        }
    };

    const handlePaste = (event) => {
        event.preventDefault();
        const text = event.clipboardData.getData('text/plain');
        document.execCommand('insertText', false, text);
    };

    const restoreSelection = () => {
        if (cursorPosition.current) {
            const sel = window.getSelection();
            sel.removeAllRanges();
            sel.addRange(cursorPosition.current);
        }
    };

    const toggleStyle = (command) => {
        restoreSelection();  // Восстановите выделение перед выполнением команды
        document.execCommand(command, false, null);
        saveSelection();
        checkCurrentStyle(); // Добавьте здесь вызов для проверки текущего стиля
    };

    const checkCurrentStyle = () => {
        const selection = document.getSelection();
        if (!selection.rangeCount) return;

        const range = selection.getRangeAt(0);
        const editableDiv = textRef.current;

        if (editableDiv && editableDiv.contains(range.commonAncestorContainer)) {
            setIsBold(document.queryCommandState('bold'));
            setIsItalic(document.queryCommandState('italic'));
            // setIsUnderline(document.queryCommandState('underline'));
            // setIsStrikeThrough(document.queryCommandState('strikeThrough'));

            const parentElement = range.commonAncestorContainer.parentElement;
            if (parentElement && parentElement.tagName === 'A') {
                setIsLink(parentElement.getAttribute('href'));
            } else {
                setIsLink('');
            }
        } else {
            setIsBold(false);
            setIsItalic(false);
            // setIsUnderline(false);
            // setIsStrikeThrough(false);
            setIsLink('');
        }
    };

    const handleMouseUp = () => {
        const selection = document.getSelection();
        if (selection.rangeCount > 0) {
            checkCurrentStyle();
        }
    };

    // Не забудьте добавить этот обработчик к вашему редактируемому контейнеру
    const editableDiv = textRef.current;
    if (editableDiv) {
        editableDiv.addEventListener('mouseup', handleMouseUp);
    }

    useEffect(() => {
        const editableDiv = textRef.current;
        if (editableDiv) {
            editableDiv.addEventListener('mouseup', handleMouseUp);
        }

        return () => {
            if (editableDiv) {
                editableDiv.removeEventListener('mouseup', handleMouseUp);
            }
        };
    }, []);

    const cleanHTML = (html) => {
        return DOMPurify.sanitize(html, {
            ALLOWED_TAGS: ['a', 'b', 'i', 'u', 'strike', 'br'],
            ALLOWED_ATTR: ['href', 'target', 'rel']
        });
    };

    const handleToggleSwitch = () => {
        setIsAutoPostingEnabled(!isAutoPostingEnabled);
    };

    const handlePostOriginal = () => {
        setPostOriginal(currentValue => {
            const newValue = !currentValue;

            setTabs((currentTabs) => {
                return currentTabs.map(tab => {
                    if (tab.id === selected) {
                        return {
                            ...tab,
                            streamData: {
                                ...tab.streamData,
                                original: newValue,
                            },
                        };
                    }
                    return tab;
                })
            });

            return newValue;
        });
    };

    const handlePostSource = () => {
        setPostSource(currentValue => {
            const newValue = !currentValue;

            setTabs((currentTabs) => {
                return currentTabs.map(tab => {
                    if (tab.id === selected) {
                        if (newValue) {
                            sourceTrue();
                        }
                        return {
                            ...tab,
                            streamData: {
                                ...tab.streamData,
                                source: newValue,
                            },
                        };
                    }
                    return tab;
                })
            });

            return newValue;
        });
    };

    const handlePostForce = () => {
        setPostForce(currentValue => {
            const newValue = !currentValue;

            setTabs((currentTabs) => {
                return currentTabs.map(tab => {
                    if (tab.id === selected) {
                        return {
                            ...tab,
                            streamData: {
                                ...tab.streamData,
                                force: newValue,
                            },
                        };
                    }
                    return tab;
                })
            });

            return newValue;
        });
    };

    const handleTheme = (e: ChangeEvent<HTMLSelectElement>) => {
        const oldTags = themes[theme]?.sources || [];
        const themeID = e.target.value;
        const selectTheme = themes[themeID];
        setTheme(themeID);

        if (selectTheme?.name) {
            Toast.show({
                icon: 'success',
                content: `Тематика установлена:\n${selectTheme.emoji + selectTheme.name}`,
            });

            // Обновление тегов и состояния вкладок в одной функции
            setTabs((currentTabs) => {
                return currentTabs.map(tab => {
                    if (tab.id === selected) {
                        const newSources = tab.streamData.sources
                            .filter(source => !oldTags.includes(source))
                            .concat(selectTheme.sources || []);

                        // Обновляем s_tags в зависимости от выбранного таба
                        s_setTags([...newSources]);

                        return {
                            ...tab,
                            streamData: {
                                ...tab.streamData,
                                sources: newSources
                            },
                        };
                    }
                    return tab;
                });
            });
        }
    };

    useEffect(() => {
        if (theme === "" || theme === null) {
            setTabs((currentTabs) => {
                return currentTabs.map(tab => {
                    if (tab.id === selected) {
                        const newSources = (tab.streamData.sources || []).filter(source => !prevThemeSources.includes(source));
                        s_setTags(newSources);

                        return {
                            ...tab,
                            streamData: {
                                ...tab.streamData,
                                sources: newSources,
                                theme: theme
                            },
                        };
                    }
                    return tab;
                })
            });
        } else {
            const oldTags = themes[theme]?.sources || [];
            setPrevThemeSources(oldTags)

            setTabs((currentTabs) => {
                return currentTabs.map(tab => {
                    if (tab.id === selected) {
                        return {
                            ...tab,
                            streamData: {
                                ...tab.streamData,
                                theme: theme
                            },
                        };
                    }
                    return tab;
                })
            });
        }
    }, [theme, themes, selected]);

    useEffect(() => {
        // Использование актуального состояния days в функции setTabs
        setTabs((currentTabs) => {
            return currentTabs.map(tab => {
                if (tab.id === selected) {
                    return {
                        ...tab,
                        streamData: {
                            ...tab.streamData,
                            promptLibrary: promptLibrary, // Используем актуальное состояние days
                        },
                    };
                }
                return tab;
            })
        });
    }, [promptLibrary]);

    const handlePostMedia = () => {
        setPostMedia(currentValue => {
            const newValue = !currentValue;

            setTabs((currentTabs) => {
                return currentTabs.map(tab => {
                    if (tab.id === selected) {
                        return {
                            ...tab,
                            streamData: {
                                ...tab.streamData,
                                media: newValue,
                            },
                        };
                    }
                    return tab;
                })
            });

            return newValue;
        });
    };

    const showModal = () => {
        const selection = window.getSelection();
        if (selection.rangeCount > 0) {
            const range = selection.getRangeAt(0);
            const parentElement = range.commonAncestorContainer.parentElement;

            if (parentElement.tagName === 'A') {
                setUrl(parentElement.getAttribute('href'));
            } else {
                setUrl('');
            }

            setSavedSelection(range);
        }
        setIsModalVisible(true);
    };

    const createLink = (url, range) => {
        const newNode = document.createElement('a');
        newNode.setAttribute('href', url);
        newNode.appendChild(range.extractContents());
        range.insertNode(newNode);
        handleTextChange(); // добавьте эту строчку
    };



    const renderTimeTag = (props) => {
        const { tag, key, disabled, onRemove, classNameRemove, getTagDisplayValue, ...other } = props;
        const handleTagRemove = (index) => {
            const newTTags = t_tags.filter((_, i) => i !== index);
            t_handleTagsChange(newTTags);
        };
        const handleRemove = (e) => {
            e.preventDefault();
            handleTagRemove(key); // вызываем вашу функцию удаления
        };

        return (
            <span key={key} {...other}>
                {getTagDisplayValue(tag)}
                {!disabled &&
                    <a className={classNameRemove} onClick={handleRemove} />
                }
            </span>
        );
    };

    function customRenderTag(props) {
        const { tag, key, disabled, onRemove, classNameRemove, getTagDisplayValue, ...other } = props;
        let favicon;
        let typeTag;

        // Проверка на начальные строки для t.me
        if (tag.startsWith("https://t.me") || tag.startsWith("http://t.me") || tag.startsWith("@") || tag.startsWith("t.me")) {
            favicon = `https://gmpeu.ru/favicon?url=${tag}`;
            typeTag = `tg_tag react-tagsinput-tag`;
        }
        // Проверка на начальные строки для vk.com
        else if (tag.startsWith("https://vk.com") || tag.startsWith("http://vk.com") || tag.startsWith("vk.com")) {
            favicon = `https://gmpeu.ru/favicon_vk?url=${tag}`;
            typeTag = `vk_tag react-tagsinput-tag`;
        }
        // Дефолтное значение
        else {
            favicon = `https://www.google.com/s2/favicons?domain=${tag}&sz=128`;
            typeTag = `react-tagsinput-tag`;
        }

        return (
            <span {...other} key={key} className={typeTag}>
                <img
                    className="img-tag"
                    src={favicon}
                    alt="favicon"
                    onError={(e) => {
                        // Устанавливаем URL плейсхолдер-изображения
                        e.target.src = 'data:image/x-icon;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAABw0lEQVQ4jV3TPWyOYRQG4Ktvf6Lo4Kcm7WSTSIhEKIuw2CxEJyISi0lDYjiRZ2tSDDZJI4gmRGLBIFEqqovEYBBrGRp/oS1V1Gf4zitfPcnJm+f83M99zv2etkajofWUUnbhMPagD214i6e4FRHPW/PbaoBSymoM43jGXuAOPmEEa/ET13AmIub/AZRSunEX+3EVJ7AOG/A6GfTiTzJ6goMRsVDlayPYl3YO/ejCe9zH+hbWDezNGu1VVe3E5bQHWMKKpP4Rm9LX1gKyhG0TExPjFQYT9TQ6UeEHDqAj7x2ZU5/2tMEKA3iUPUuQTtzDeZzEqyyoQWo2Ax3Z73XMpi3liz24gVW4ibn0S4az6K+HOIyv+JyBmSz6jg/JaDfG8RBbUCTiNDZnUt1rl6ak77BG8x+YwVH8ykcPYbrCZA7qt6bODSxiPvu+1EJ7Cb0RMYMdmKwwloF6QPW3Pf09WMg7fCmlXMz7WBURUxhNFo0MfMPaiOjQlLkbK5NhH07hSkRM1UMcwuMWeeahlLIdG7EYEW80ZX2mKfsQy5epJ9U4lmxe4oLmPhzB1hzyKM5GxNwygPr8t8796a7X+XZETLbm/wX/KpPYQGOnwgAAAABJRU5ErkJggg==';
                    }}
                />
                {getTagDisplayValue(tag).length > 23
                    ? getTagDisplayValue(tag).slice(0, 23) + "..."
                    : getTagDisplayValue(tag)}
                {!disabled && (
                    <a className={classNameRemove} onClick={(e) => onRemove(key)} />
                )}
            </span>
        );
    }

    const handleOk = () => {
        if (url && savedSelection) {
            createLink(url, savedSelection);
            setIsModalVisible(false);
            setUrl('');
            setSavedSelection(null);
            handleTextChange();
        }
    };

    const removeLink = () => {
        const selection = window.getSelection();
        if (selection.rangeCount > 0) {
            const range = selection.getRangeAt(0);
            const parentElement = range.commonAncestorContainer.parentElement;
            if (parentElement && parentElement.tagName === 'A') {
                const linkText = parentElement.textContent;
                const parentNode = parentElement.parentNode;

                // Replace the <a> tag with its text content
                parentNode.insertBefore(document.createTextNode(linkText), parentElement);
                parentNode.removeChild(parentElement);

                // Clear link in state
                setIsLink('');
                setUrl('');
                setIsModalVisible(false);
                setSavedSelection(null);
                handleTextChange(); // добавьте эту строчку
            }
        }
    };

    const handlePromptChange = (e) => {
        const newValue = e.target.value;

        // Обновляем локальное состояние для отображения в UI
        set_PromptInput(newValue);

        // Обновляем общее состояние для текущей активной вкладки с новым текстом
        setTabs((currentTabs) => {
            return currentTabs.map(tab => {
                if (tab.id === selected) {
                    return {
                        ...tab,
                        // Обновляем свойство промпта в данных вкладки
                        // Вам нужно будет адаптировать путь в объекте под вашу структуру
                        // Например, если промпт является частью streamData
                        streamData: {
                            ...tab.streamData,
                            prompt: newValue,
                        },
                    };
                }
                return tab;
            });
        });
    };

    const handleSignChange = (e) => {
        const newValue = e.target.value;

        // Обновляем локальное состояние для отображения в UI
        setSign(newValue);

        // Обновляем общее состояние для текущей активной вкладки с новым текстом
        setTabs((currentTabs) => {
            return currentTabs.map(tab => {
                if (tab.id === selected) {
                    return {
                        ...tab,
                        // Обновляем свойство промпта в данных вкладки
                        // Вам нужно будет адаптировать путь в объекте под вашу структуру
                        // Например, если промпт является частью streamData
                        streamData: {
                            ...tab.streamData,
                            sign: newValue,
                        },
                    };
                }
                return tab;
            });
        });
    };

    const changeActiveModal = (activeModal) => {
        activeModal = activeModal || null;
        let localModalHistory = modalHistory ? [...modalHistory] : [];

        if (activeModal === null) {
            localModalHistory = [];
        } else if (modalHistory.indexOf(activeModal) !== -1) {
            localModalHistory = localModalHistory.splice(0, localModalHistory.indexOf(activeModal) + 1);
        } else {
            localModalHistory.push(activeModal);
        }

        setActiveModal(activeModal);
        setModalHistory(localModalHistory);
    };

    const modalBack = () => {
        changeActiveModal(modalHistory[modalHistory.length - 2]);
    };

    useEffect(() => {
        if (isClearingInputS && s_inputRef.current) {
            s_inputRef.current.clearInput();
            setIsClearingInputS(false);
        }
    }, [isClearingInputS]);

    useEffect(() => {
        if (isClearingInputK && k_inputRef.current) {
            k_inputRef.current.clearInput();
            setIsClearingInputK(false);
        }
    }, [isClearingInputK]);

    useEffect(() => {
        if (isClearingInputN && n_inputRef.current) {
            n_inputRef.current.clearInput();
            setIsClearingInputN(false);
        }
    }, [isClearingInputN]);

    useEffect(() => {
        if (isClearingInputT && t_inputRef.current) {
            t_inputRef.current.clearInput();
            setIsClearingInputT(false);
        }
    }, [isClearingInputT]);

    const s_handleTagsChange = (tags) => {
        const uniqueTags = [...new Set(tags)].filter(tag => tag.trim().length > 0);

        s_setTags(uniqueTags);  // Обновление локального состояния тегов

        setTabs((prevTabs) => {
            return prevTabs.map((tab) => {
                if (tab.id === selected) {
                    // Отфильтруйте дубликаты и пустые теги
                    const noDuplicateTags = [...new Set(tags)];
                    const uniqueTags = noDuplicateTags.filter((tag, index) => {
                        const trimmedTag = tag.trim();
                        return trimmedTag.length > 0 && noDuplicateTags.indexOf(trimmedTag) === index;
                    });
                    return { ...tab, streamData: { ...tab.streamData, sources: uniqueTags } };
                }
                return tab;
            });
        });
        // Очистите текущий введенный тег
        s_setCurrentTag('');
    };

    const s_handleTagInputChange = (e) => {
        s_setCurrentTag(e.target.value);
        const lastChar = e.target.value.slice(-1);

        // Проверка на наличие ссылки, начинающейся с "https://t.me/+"
        if (e.target.value.startsWith('https://t.me/+')) {
            openErrorTg();
        }

        if (lastChar === ',') {
            const newTag = e.target.value.slice(0, -1).trim();

            if (newTag.length >= 2) {
                const noDuplicateTags = [...new Set([...s_tags, newTag])];
                const uniqueTags = noDuplicateTags.filter((tag) => tag.trim().length > 0);
                s_setTags(uniqueTags);
                s_setCurrentTag("");
                setIsClearingInputS(true);

                setTabs((prevTabs) => {
                    return prevTabs.map((tab) => {
                        if (tab.id === selected) {
                            return { ...tab, streamData: { ...tab.streamData, sources: noDuplicateTags } };
                        }
                        return tab;
                    });
                });
                s_setCurrentTag('');
            }
        }
    };

    const k_handleTagsChange = (tags) => {
        const uniqueTags = [...new Set(tags)].filter(tag => tag.trim().length > 0);

        k_setTags(uniqueTags);  // Обновление локального состояния тегов

        setTabs((prevTabs) => {
            return prevTabs.map((tab) => {
                if (tab.id === selected) {
                    // Отфильтруйте дубликаты и пустые теги
                    const noDuplicateTags = [...new Set(tags)];
                    const uniqueTags = noDuplicateTags.filter((tag, index) => {
                        const trimmedTag = tag.trim();
                        return trimmedTag.length > 0 && noDuplicateTags.indexOf(trimmedTag) === index;
                    });
                    return { ...tab, streamData: { ...tab.streamData, keywords: uniqueTags } };
                }
                return tab;
            });
        });
        // Очистите текущий введенный тег
        k_setCurrentTag('');
    };

    const k_handleTagInputChange = (e) => {
        k_setCurrentTag(e.target.value);
        const lastChar = e.target.value.slice(-1);

        if (lastChar === ',') {
            const newTag = e.target.value.slice(0, -1).trim();

            if (newTag.length >= 2) {
                const noDuplicateTags = [...new Set([...k_tags, newTag])];
                const uniqueTags = noDuplicateTags.filter((tag) => tag.trim().length > 0);
                k_setTags(uniqueTags);
                k_setCurrentTag("");
                setIsClearingInputK(true);

                setTabs((prevTabs) => {
                    return prevTabs.map((tab) => {
                        if (tab.id === selected) {
                            return { ...tab, streamData: { ...tab.streamData, keywords: noDuplicateTags } };
                        }
                        return tab;
                    });
                });
                k_setCurrentTag('');
            }
        }
    };

    const n_handleTagsChange = (tags) => {
        const uniqueTags = [...new Set(tags)].filter(tag => tag.trim().length > 0);

        n_setTags(uniqueTags);  // Обновление локального состояния тегов

        setTabs((prevTabs) => {
            return prevTabs.map((tab) => {
                if (tab.id === selected) {
                    // Отфильтруйте дубликаты и пустые теги
                    const noDuplicateTags = [...new Set(tags)];
                    const uniqueTags = noDuplicateTags.filter((tag, index) => {
                        const trimmedTag = tag.trim();
                        return trimmedTag.length > 0 && noDuplicateTags.indexOf(trimmedTag) === index;
                    });
                    return { ...tab, streamData: { ...tab.streamData, negative: uniqueTags } };
                }
                return tab;
            });
        });
        // Очистите текущий введенный тег
        n_setCurrentTag('');
    };

    const n_handleTagInputChange = (e) => {
        n_setCurrentTag(e.target.value);
        const lastChar = e.target.value.slice(-1);

        if (lastChar === ',') {
            const newTag = e.target.value.slice(0, -1).trim();

            if (newTag.length >= 2) {
                const noDuplicateTags = [...new Set([...n_tags, newTag])];
                const uniqueTags = noDuplicateTags.filter((tag) => tag.trim().length > 0);
                n_setTags(uniqueTags);
                n_setCurrentTag("");
                setIsClearingInputN(true);

                setTabs((prevTabs) => {
                    return prevTabs.map((tab) => {
                        if (tab.id === selected) {
                            return { ...tab, streamData: { ...tab.streamData, negative: noDuplicateTags } };
                        }
                        return tab;
                    });
                });
                n_setCurrentTag('');
            }
        }
    };

    // Функция, которая заменяет все нецифровые символы на 0
    const handleNumericInput = (e) => {
        e.target.value = e.target.value.replace(/[^0-9:]/g, '0');
    };

    const t_handleTagsChange = (tags) => {
        const uniqueTags = [...new Set(tags)].filter(tag => tag.trim().length > 0);

        t_setTags(uniqueTags);  // Обновление локального состояния тегов

        setTabs((prevTabs) => {
            return prevTabs.map((tab) => {
                if (tab.id === selected) {
                    // Отфильтруйте дубликаты и пустые теги
                    const noDuplicateTags = [...new Set(tags)];
                    const uniqueTags = noDuplicateTags.filter((tag, index) => {
                        const trimmedTag = tag.trim();
                        return trimmedTag.length > 0 && noDuplicateTags.indexOf(trimmedTag) === index;
                    });
                    return { ...tab, streamData: { ...tab.streamData, timer: uniqueTags } };
                }
                return tab;
            });
        });
        // Очистите текущий введенный тег
        t_setCurrentTag('');
    };

    const handleTagRemove = (index) => {
        console.log('tag has been removed')
        // Удаление по тому же индексу из t_tags
        // const newTTags = t_tags.filter((_, i) => i !== index);
        // setTTags(newTTags);
    };


    const t_handleTagInputChange = (e) => {
        t_setCurrentTag(e.target.value);
        const inputValue = e.target.value.trim();

        if (inputValue.length === 2) {
            const newTag = inputValue.slice(0, 2) + ":";
            t_setCurrentTag(newTag);
        } else if (inputValue.length === 5) {
            const newTag = inputValue.trim();

            if (newTag.length >= 2) {
                const noDuplicateTags = [...new Set([...t_tags, newTag].slice(0, 999))];
                const uniqueTags = noDuplicateTags.filter((tag) => tag.trim().length > 0);

                setTabs((prevTabs) => {
                    return prevTabs.map((tab) => {
                        if (tab.id === selected) {
                            return { ...tab, streamData: { ...tab.streamData, timer: noDuplicateTags } };
                        }
                        return tab;
                    });
                });

                t_setTags(uniqueTags);
                t_setCurrentTag("");
                setIsClearingInputT(true);
            }
        }
    };

    // Функция для уменьшения значения "Креативности"
    const decreaseValueGpt = () => {
        setGptTemp(prevValue => Math.max(Math.round((prevValue - 0.1) * 10) / 10, 0.4)); // Обновление переменной состояния при нажатии на кнопку
        // Обновляем только для активной вкладки
        setTabs(tabs => tabs.map(tab => {
            if (tab.id === selected) {
                return {
                    ...tab,
                    streamData: {
                        ...tab.streamData,
                        temp: Math.max(Math.round((gptTemp - 0.1) * 10) / 10, 0.4),
                    }
                };
            }
            return tab;
        }));
    };

    // Функция для увеличения значения "Креативности"
    const increaseValueGpt = () => {
        setGptTemp(prevValue => Math.min(Math.round((prevValue + 0.1) * 10) / 10, 1)); // Обновление переменной состояния при нажатии на кнопку
        // Обновляем только для активной вкладки
        setTabs(tabs => tabs.map(tab => {
            if (tab.id === selected) {
                return {
                    ...tab,
                    streamData: {
                        ...tab.streamData,
                        temp: Math.min(Math.round((gptTemp + 0.1) * 10) / 10, 1),
                    }
                };
            }
            return tab;
        }));
    };

    const handleTempChange = (newValue) => {
        setGptTemp(newValue)
        setTabs(tabs => tabs.map(tab => {
            if (tab.id === selected) {
                return {
                    ...tab,
                    streamData: {
                        ...tab.streamData,
                        temp: newValue,
                    },
                };
            }
            return tab;
        }));
    };

    const handlePasteSplit = (data) => {
        return data.split(/[\n,]+/).map((d) => d.trim());
    };

    const gptTestDrive = async (event) => {
        setLoading(true);
        setLoadingScreen('flex');

        try {
            const response = await axios.post('https://gmpeu.ru/get_summary', {
                urls: s_tags,
                keywords: k_tags,
                negative: n_tags,
                temp: gptTemp,
                prompt: prompt_input,
                sign: sign,
                theme: theme,
                force: postForce,
                tg_id: tg.initDataUnsafe.user.id,
                token: userInfo.token
            });

            setLoading(false);
            setLoadingScreen('none');
            const summary = response.data.summary.replace(/\\n/g, "\n");
            const title = response.data.title;
            const link = response.data.url;
            const image_url = response.data.image_url;

            setTestTitle(title);
            setTestLink(link);
            setTestImage(image_url);
            setTestSummary(summary);

            setGptLink(link);
            setGptMedia(image_url);
            setGptText(summary);

            tg.MainButton.hide();
            sendDataTwo(tabs, userInfo, selectedGroup);
            setActiveView('testgpt');

        } catch (error) {
            setLoading(false);
            setLoadingScreen('none');
            openErrorGPT();
        }
    };

    // Функция для отправки данных, принимает дополнительные параметры
    function sendData(tabs, userInfo, selectedGroup) {
        // Подготовка данных из tabs
        const streams = tabs.map((tab, index) => {
            return {
                id: index,
                streamData: tab.streamData
            };
        });

        const getApiUrl = (id) => {
            if (id <= 0) {
                return 'https://api.gmpapp.ru/save_channel';
            } else {
                return 'https://api.gmpapp.ru/save_group';
            }
        };

        const getId = (id) => {
            if (id <= 0) {
                return tg.initDataUnsafe.user.id;
            } else {
                return userInfo.id;
            }
        };

        const apiUrl = getApiUrl(selectedGroup.id);
        const idToSend = getId(selectedGroup.id);

        // Формирование объекта с данными
        const dataToSend = {
            id: idToSend,
            token: userInfo.token,
            group_id: selectedGroup.id,
            active: isAutoPostingEnabled,
            premode: isPremodeEnabled,
            premode_time: premodeTime,
            streams: streams
        };

        if (s_tags.length === 0 && t_tags.length === 0) {
            openError('«Источники» и «Время постинга»');
            return;
        }

        if (s_tags.length === 0 && theme.length === 0) {
            openError('поле «Источники»');
            return;
        }

        if (t_tags.length === 0) {
            openError('поле «Время постинга»');
            return;
        }

        if (days.length === 0) {
            openError('дни недели в поле «Время постинга»');
            return;
        }

        const isTimerFilledInAllStreams = streams.every(stream => stream.streamData.timer && stream.streamData.timer.length > 0);
        const isSourcesFilledInAllStreams = streams.every(stream => stream.streamData.sources && stream.streamData.sources.length > 0);

        const emptyTimerStreams = streams.filter(stream => !(stream.streamData.timer && stream.streamData.timer.length > 0));
        const emptySourcesStreams = streams.filter(stream => {
            const sourcesEmpty = !(stream.streamData.sources && stream.streamData.sources.length > 0);
            const themeEmpty = !(stream.streamData.theme && stream.streamData.theme.length > 0);

            return sourcesEmpty && themeEmpty;
        });
        const emptyDaysStreams = streams.filter(stream => !(stream.streamData.days && stream.streamData.days.length > 0));

        const defaultDays = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

        if (emptyTimerStreams.length > 0 && emptySourcesStreams.length > 0) {
            openError('«Источники» и «Время постинга» в каждой рубрике');
            return;
        }

        if (emptyTimerStreams.length > 0) {
            openError('поле «Время постинга» в каждой рубрике');
            return;
        }

        if (emptySourcesStreams.length > 0) {
            openError('поле «Источники» в каждой рубрике');
            return;
        }

        if (emptyDaysStreams.length > 0) {
            emptyDaysStreams.forEach(stream => {
                stream.streamData.days = defaultDays;
            });
        }

        // Отправка данных
        axios.post(apiUrl, dataToSend)
            .then((response) => {
                setActiveView('view1');
            })
            .catch((error) => {
                console.error('Ошибка при отправке данных', error);
            });
    }

    // Функция для отправки данных, принимает дополнительные параметры
    function sendDataTwo(tabs, userInfo, selectedGroup) {
        setSaveState(true);

        // Подготовка данных из tabs
        const streams = tabs.map((tab, index) => {
            return {
                id: index,
                streamData: tab.streamData
            };
        });

        if (s_tags.length === 0 && t_tags.length === 0) {
            openError('«Источники» и «Время постинга»');
            return;
        }

        if (s_tags.length === 0 && theme.length === 0) {
            openError('поле «Источники»');
            return;
        }

        if (t_tags.length === 0) {
            openError('поле «Время постинга»');
            return;
        }

        if (days.length === 0) {
            openError('дни недели в поле «Время постинга»');
            return;
        }

        const isTimerFilledInAllStreams = streams.every(stream => stream.streamData.timer && stream.streamData.timer.length > 0);
        const isSourcesFilledInAllStreams = streams.every(stream => stream.streamData.sources && stream.streamData.sources.length > 0);

        const emptyTimerStreams = streams.filter(stream => !(stream.streamData.timer && stream.streamData.timer.length > 0));
        const emptySourcesStreams = streams.filter(stream => {
            const sourcesEmpty = !(stream.streamData.sources && stream.streamData.sources.length > 0);
            const themeEmpty = !(stream.streamData.theme && stream.streamData.theme.length > 0);

            return sourcesEmpty && themeEmpty;
        });
        const emptyDaysStreams = streams.filter(stream => !(stream.streamData.days && stream.streamData.days.length > 0));

        const defaultDays = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

        if (emptyTimerStreams.length > 0 && emptySourcesStreams.length > 0) {
            openError('«Источники» и «Время постинга» в каждой рубрике');
            setSaveState(false);
            return;
        }

        if (emptyTimerStreams.length > 0) {
            openError('поле «Время постинга» в каждой рубрике');
            setSaveState(false);
            return;
        }

        if (emptySourcesStreams.length > 0) {
            openError('поле «Источники» в каждой рубрике');
            setSaveState(false);
            return;
        }

        if (emptyDaysStreams.length > 0) {
            emptyDaysStreams.forEach(stream => {
                stream.streamData.days = defaultDays;
            });
        }


        const getApiUrl = (id) => {
            if (id <= 0) {
                return 'https://api.gmpapp.ru/save_channel';
            } else {
                return 'https://api.gmpapp.ru/save_group';
            }
        };

        const getId = (id) => {
            if (id <= 0) {
                return tg.initDataUnsafe.user.id;
            } else {
                return userInfo.id;
            }
        };

        const apiUrl = getApiUrl(selectedGroup.id);
        const idToSend = getId(selectedGroup.id);

        // Формирование объекта с данными
        const dataToSend = {
            id: idToSend,
            group_id: selectedGroup.id,
            active: isAutoPostingEnabled,
            premode: isPremodeEnabled,
            premode_time: premodeTime,
            streams: streams
        };

        // Отправка данных
        axios.post(apiUrl, dataToSend)
            .then((response) => {
                console.log('all saves')
                setSaveState(false);
                openSave();
            })
            .catch((error) => {
                console.error('Ошибка при отправке данных', error);
                setSaveState(false);
                openErrorSave();
            });
    }

    function sendDataPosts(tabs, userInfo, selectedGroup) {
        // Подготовка данных из tabs
        const streams = tabs.map((tab, index) => {
            return {
                id: index,
                streamData: tab.streamData
            };
        });

        if (s_tags.length === 0 && t_tags.length === 0) {
            openError('«Источники» и «Время постинга»');
            return;
        }

        if (s_tags.length === 0) {
            openError('поле «Источники»');
            return;
        }

        if (t_tags.length === 0) {
            openError('поле «Время постинга»');
            return;
        }

        if (days.length === 0) {
            openError('дни недели в поле «Время постинга»');
            return;
        }

        const isTimerFilledInAllStreams = streams.every(stream => stream.streamData.timer && stream.streamData.timer.length > 0);
        const isSourcesFilledInAllStreams = streams.every(stream => stream.streamData.sources && stream.streamData.sources.length > 0);

        const emptyTimerStreams = streams.filter(stream => !(stream.streamData.timer && stream.streamData.timer.length > 0));
        const emptySourcesStreams = streams.filter(stream => {
            const sourcesEmpty = !(stream.streamData.sources && stream.streamData.sources.length > 0);
            const themeEmpty = !(stream.streamData.theme && stream.streamData.theme.length > 0);

            return sourcesEmpty && themeEmpty;
        });
        const emptyDaysStreams = streams.filter(stream => !(stream.streamData.days && stream.streamData.days.length > 0));

        const defaultDays = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

        if (emptyTimerStreams.length > 0 && emptySourcesStreams.length > 0) {
            openError('«Источники» и «Время постинга» в каждой рубрике');
            return;
        }

        if (emptyTimerStreams.length > 0) {
            openError('поле «Время постинга» в каждой рубрике');
            return;
        }

        if (emptySourcesStreams.length > 0) {
            openError('поле «Источники» в каждой рубрике');
            return;
        }

        if (emptyDaysStreams.length > 0) {
            emptyDaysStreams.forEach(stream => {
                stream.streamData.days = defaultDays;
            });
        }


        const getApiUrl = (id) => {
            if (id <= 0) {
                return 'https://api.gmpapp.ru/save_channel';
            } else {
                return 'https://api.gmpapp.ru/save_group';
            }
        };

        const getId = (id) => {
            if (id <= 0) {
                return tg.initDataUnsafe.user.id;
            } else {
                return userInfo.id;
            }
        };

        const apiUrl = getApiUrl(selectedGroup.id);
        const idToSend = getId(selectedGroup.id);

        // Формирование объекта с данными
        const dataToSend = {
            id: idToSend,
            group_id: selectedGroup.id,
            active: isAutoPostingEnabled,
            premode: isPremodeEnabled,
            premode_time: premodeTime,
            streams: streams
        };

        // Отправка данных
        axios.post(apiUrl, dataToSend)
            .then((response) => {
                setActiveView('premode');
            })
            .catch((error) => {
                console.error('Ошибка при отправке данных', error);
            });
    }

    useEffect(() => {
        checkIfEmpty();
        if (textRef.current && cursorPosition.current) {
            restoreSelection();
        }
    }, [sign]);

    const [messageIndex, setMessageIndex] = useState(0);
    const [dots, setDots] = useState('');
    const messages = [
        "Ищем новости",
        "Выбираем лучшую",
        "Делаем рерайт",
        "Генерируем пост"
    ];

    useEffect(() => {
        if (!loadingScreen) return; // Если loadingScreen не true, ничего не делаем

        const interval = setInterval(() => {
            if (messageIndex < messages.length - 1) {
                setMessageIndex(prevIndex => prevIndex + 1);
            }
        }, 2500);

        return () => clearInterval(interval); // Очистка интервала при размонтировании компонента
    }, [loadingScreen, messageIndex]);

    useEffect(() => {
        if (!loadingScreen) return; // Если loadingScreen не true, ничего не делаем

        const dotInterval = setInterval(() => {
            setDots(prevDots => {
                if (prevDots.length < 3) {
                    return prevDots + '.';
                } else {
                    return '';
                }
            });
        }, 500); // Измените интервал, если нужно

        return () => clearInterval(dotInterval); // Очистка интервала при размонтировании компонента
    }, [loadingScreen, messageIndex]);

    const generatingPostOpt = {
        loop: true,
        autoplay: true,
        animationData: generatingPost,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    };

    return (
        <>
        <div className="loadingState" style={{ height: '100vh', justifyContent: 'center', alignItems: 'center', display: loadingState ? 'flex' : 'none' }}>
            <SpinLoading />
        </div>
        
        <div className="inputBody" style={{ display: loadingState ? 'none' : '' }}>
            <Panel className="settingsGroups">
                <div className="overlaySpinner" style={{ display: loadingScreen }}>
                    <Lottie
                        isClickToPauseDisabled={true}
                        options={generatingPostOpt}
                        height={150}
                        width={150}
                    />
                    <motion.div
                        style={{ paddingTop: "40px" }}
                        key={messageIndex}
                        initial={{ opacity: 0, y: -20 }} // Начальная анимация
                        animate={{ opacity: 1, y: 0 }} // Конечная анимация
                        exit={{ opacity: 0, y: 20 }} // Анимация выхода
                        transition={{ duration: 1 }} // Длительность анимации
                    >
                        <span>{messages[messageIndex]}{dots}</span>
                    </motion.div>
                </div>
                <Group>
                    <div className="headerFirst" style={{ display: "flex" }}>
                        <Banner
                            className="channelTitle"
                            before={<Avatar size={48} initials={selectedGroup?.name.slice(0, 2)}
                                src={avatarSrc} />}
                            header={selectedGroup?.name}
                            subheader={`${selectedGroup?.members_count} подписчиков`}
                        />
                        <Button
                            className={`communityButton ${isAutoPostingEnabled ? "postingOn" : "postingOff"}`}
                            before={isAutoPostingEnabled ? <Icon20RadioOn /> : <Icon20RadioOff />}
                            size='l'
                            stretched
                            onClick={handleToggleSwitch}
                        >
                            <span className="headerButtonWrapper">
                                <span className="headerButtonTitle">Постинг</span>
                                <span className="headerButtonDesc">{isAutoPostingEnabled ? "Включен" : "Выключен"}</span>
                            </span>
                        </Button>
                    </div>
                    <div className="headerSettings">
                        <Button className="communityButton"
                            before={<Icon24RobotOutline />}
                            size='l'
                            stretched
                            onClick={gptTestDrive}
                        >
                            <span className="headerSubButtonTitle">Тест-драйв</span>
                        </Button>
                        <Button className="communityButton"
                            before={<Icon24Squareshape4VerticalLeftOutline />}
                            size='l'
                            stretched
                            onClick={() => { sendDataPosts(tabs, userInfo, selectedGroup); }}
                        >
                            <span className="headerSubButtonTitle">Посты {postCount > 0 && (<Counter size="s" mode="primary">{postCount}</Counter>)}</span>
                        </Button>
                        <Button className="communityButton"
                            before={<Icon24HelpOutline />}
                            size='l'
                            stretched
                            onClick={communityLink}
                        >
                            <span className="headerSubButtonTitle">Помощь</span>
                        </Button>
                    </div>
                    <Spacing size={46}>
                        <Separator />
                    </Spacing>
                    {/* <SimpleCell className="switchAuto" after={<Switch checked={isAutoPostingEnabled} onChange={handleToggleSwitch} />} style={{ padding: '0' }}>
                        Активировать постинг
                    </SimpleCell> */}
                    <FormItem
                        className="gmpMode"
                        top={
                            <span className="inputTitle">
                                <span className="inputTitleFirst">
                                    <span>🤖 Режим работы</span>
                                </span>
                                <span className="helpModal"
                                    onClick={() => {
                                        Modal.alert({
                                            title: 'Режим работы',
                                            content: 'Здесь вы можете выбрать в каком режиме будет работать сервис. Если выбран «Автопостинг», то публикация будут выходить сразу, а если «Премодерация», то сервис будет присылать публикацию на модерацию перед постингом',
                                            closeOnMaskClick: true,
                                            showCloseButton: true
                                        })
                                    }}
                                >
                                    {<Icon20HelpOutline />}
                                </span>
                            </span>
                        }
                    >
                        <Radio.Group value={initialRadioValue} onChange={(e) => handleRadioChange(e)}>
                            <Space direction='horizontal' className="modeContainer">
                                <Radio value="false">Автопостинг</Radio>
                                <Radio value="true">Премодерация</Radio>
                            </Space>
                        </Radio.Group>
                        {isPremodeEnabled === true ? (
                            <FormItem
                                top="Предупредить за"
                                htmlFor="premode"
                            >
                                <Select
                                    id="premode"
                                    placeholder="Выберите время"
                                    value={premodeTime}
                                    onChange={handlePremodeChange}
                                    options={options}
                                />
                            </FormItem>
                        ) : null}
                    </FormItem>
                </Group>
                <FormItem
                    htmlFor="list"
                    top={
                        <span className="inputTitle">
                            <span>📁 Рубрики</span>
                            <span className="helpModal">
                                <Button
                                    appearance="neutral"
                                    before={<Icon24Add />}
                                    size='m'
                                    onClick={() => {
                                        setTimeout(() => {
                                            addTab();
                                        }, 0);

                                        setTimeout(() => {
                                            textRef.current.blur();
                                        }, 5);
                                    }}
                                    style={{ minWidth: "36px", backgroundColor: "var(--vkui--color_background_tertiary--active)" }}
                                >
                                </Button>
                            </span>
                        </span>
                    }
                >
                    {renameStreamModal && (
                        <Modal
                            title="Переименовать рубрику"
                            visible={renameStreamModal}
                            closeOnMaskClick
                            showCloseButton
                            closeOnAction
                            onClose={() => {
                                setRenameStreamModal(false);
                            }}
                            content={
                                <div className="url-modal">
                                    <Input
                                        ref={streamNameRef}
                                        placeholder='Введите название рубрики'
                                        defaultValue={tabs[selected].name}
                                        onChange={(value) => setNewStreamName(value)}
                                    />
                                    <Button
                                        size="l"
                                        appearance="positive"
                                        stretched
                                        onClick={renameTab}
                                    >
                                        Сохранить
                                    </Button>
                                </div>
                            }
                        >
                        </Modal>
                    )}
                    <Tabs
                        mode={mode}
                    >
                        <HorizontalScroll arrowSize="m">
                            {tabs.length > 1 && tabs.map((tab) => (
                                <TabsItem
                                    key={tab.id}
                                    before={tab.icon}
                                    selected={selected === tab.id}
                                    onClick={() => {
                                        setTimeout(() => {
                                            selectTab(tab.id);
                                        }, 0);

                                        setTimeout(() => {
                                            textRef.current.blur();
                                        }, 5);
                                    }}
                                >
                                    {tab.name}
                                </TabsItem>
                            ))}
                        </HorizontalScroll>
                    </Tabs>
                </FormItem>
                <Div style={{ padding: 0, display: "flex", flexDirection: "column" }}>
                    {tabs.length > 1 && selected !== 'main' && (
                        <ButtonGroup mode="horizontal" gap="m">
                            <Button
                                appearance="accent"
                                before={<Icon24Write />}
                                size='m'
                                stretched
                                onClick={handleRenameTab}
                                style={{ minWidth: "36px" }}
                            >Переименовать
                            </Button>
                            <Button
                                appearance="negative"
                                before={<Icon24Delete />}
                                size='m'
                                onClick={() => {
                                    tg.showPopup({
                                        title: "Удалить рубрику",
                                        message: `Вы действительно хотите удалить рубрику «${tabs[selected].name}»? Источники, ключевые слова, промпт и время постинга будут очищены`,
                                        buttons: [
                                            { id: 'delete', type: 'destructive', text: 'Удалить' },
                                            { id: 'cancel', type: 'cancel' },
                                        ]
                                    }, (buttonId) => {
                                        if (buttonId === 'cancel') {
                                            console.log("Действие отменено");
                                        } else if (buttonId === 'delete') {
                                            setTimeout(() => {
                                                removeTab(selected);
                                            }, 0);

                                            setTimeout(() => {
                                                textRef.current.blur();
                                            }, 5);
                                        }
                                    });
                                }}
                                style={{ minWidth: "36px" }}
                            >Удалить
                            </Button>
                        </ButtonGroup>
                    )}
                </Div>
                {text && (
                    <Group>
                        <Div>{text}</Div>
                    </Group>
                )}

                {snackbar}
            </Panel>
            <Spacing size={26}>
                <Separator />
            </Spacing>
            <FormItem
                htmlFor="list"
                top={
                    <span className="inputTitle">
                        <span>Источники</span>
                        <span className="helpModal"
                            onClick={() => {
                                Modal.alert({
                                    title: 'Источники',
                                    content: 'Поле «Источники» предназначено для внесения информации о различных сайтах и телеграм-каналах, из которых вы хотите получать новости или данные. В это поле можно вводить адреса сайтов в произвольной форме - как с протоколом http или https, так и без него. Например, вы можете указать example.com или https://example.com"\n' +
                                        '\n' +
                                        'Также вы можете добавлять телеграм-каналы для парсинга новостей. Для этого можно указывать название канала в формате @channelname или полный URL-адрес телеграм-канала в формате https://t.me/ChannelName. Оба формата будут обработаны и использованы для парсинга новостей из указанных каналов\n' +
                                        '\n' +
                                        'После добавления источников бот будет просматривать эти сайты и каналы для получения свежих новостей и информации.',
                                    closeOnMaskClick: true,
                                    showCloseButton: true,
                                    disableBodyScroll: true
                                })
                            }}
                        >
                            {<Icon20HelpOutline />}
                        </span>
                    </span>
                }
            >
                <FormItem
                    htmlFor="list"
                    top={
                        <span className="inputTitle">
                            <span>Список источников</span>
                            <span className="helpModal"
                                onClick={() => {
                                    Modal.alert({
                                        title: 'Источники',
                                        content: 'Поле «Мои источники» предназначено для внесения информации о различных сайтах и телеграм-каналах, из которых вы хотите получать новости или данные. В это поле можно вводить адреса сайтов в произвольной форме - как с протоколом http или https, так и без него. Например, вы можете указать example.com или https://example.com"\n' +
                                            '\n' +
                                            'Также вы можете добавлять телеграм-каналы для парсинга новостей. Для этого можно указывать название канала в формате @channelname или полный URL-адрес телеграм-канала в формате https://t.me/ChannelName. Оба формата будут обработаны и использованы для парсинга новостей из указанных каналов\n' +
                                            '\n' +
                                            'После добавления источников бот будет просматривать эти сайты и каналы для получения свежих новостей и информации.',
                                        closeOnMaskClick: true,
                                        showCloseButton: true,
                                        disableBodyScroll: true
                                    })
                                }}
                            >
                                {/* {<Icon20HelpOutline />} */}
                            </span>
                        </span>
                    }
                >
                    <div className={`groupInput sources`}>
                        <TagsInput
                            id="list"
                            ref={s_inputRef}
                            value={s_tags}
                            onChange={s_handleTagsChange}
                            addOnBlur={true}
                            pasteSplit={handlePasteSplit}
                            renderTag={customRenderTag}
                            tagProps={{
                                className: 'react-tagsinput-tag source-tag',
                                classNameRemove: 'react-tagsinput-remove',
                            }}
                            inputProps={{
                                value: s_currentTag,
                                className: 'sources-input react-tagsinput-input',
                                placeholder: s_tags.length > 0 ? "" : "Введите источники",
                                onChange: s_handleTagInputChange,
                            }}
                            addOnPaste
                        />
                    </div>
                </FormItem>
                <FormItem
                    top="Тематики"
                    htmlFor="themes"
                    className="themesContainer"
                >
                    <Select
                        id="themes"
                        placeholder="Не выбрано"
                        className="themes-select"
                        value={theme}
                        allowClearButton
                        onChange={handleTheme}
                        options={themes
                            .slice() // Создаем копию массива, чтобы не мутировать исходный
                            .sort((a, b) => a.name.localeCompare(b.name)) // Сортировка по алфавиту
                            .map((theme) => ({
                                label: theme.emoji + theme.name,
                                value: theme.id,
                            }))}
                        renderOption={({ option, ...restProps }) => (
                            <CustomSelectOption
                                {...restProps}
                                key={option.value}
                            />
                        )}
                    />
                </FormItem>
            </FormItem>
            <FormItem
                className="prompt"
                style={{ display: postSource ? 'none' : 'block' }}
                top={
                    <span className="inputTitle">
                        <span>Стиль публикации</span>
                        <span className="helpModal"
                            onClick={() => {
                                Modal.alert({
                                    title: 'Промпт',
                                    content: 'Поле «Промпт» предназначено для ввода задания или инструкций, которые передаются модели ChatGPT и влияют на конечное автоматическое резюмирование новости. Например:\n' +
                                        '\n' +
                                        '1. Указание на основную информацию: "Резюмируй основную информацию из новости, включая место и главных участников".\n' +
                                        '\n' +
                                        '2. Определение конкретных аспектов: "Сфокусируйся на экономических последствиях данной ситуации" или "Выдели ключевые моменты из новости".\n' +
                                        '\n' +
                                        '3. Запрос краткого резюме: "Предоставь краткое и информативное резюме новости в одном предложении".\n' +
                                        '\n' +
                                        'Важно подобрать формулировку в поле «Промпт», чтобы быть ясным и точным и дать модели понимание того, какая информация вам необходима в резюме каждой новости.',
                                    closeOnMaskClick: true,
                                    showCloseButton: true
                                })
                            }}
                        >
                            {<Icon20HelpOutline />}
                        </span>
                    </span>
                }
            >
                {/* <FormItem
                    top="Библиотека шаблонов"
                    htmlFor="prompts"
                >
                    <Select
                        id="prompts"
                        placeholder="Не выбрано"
                        value={promptLibrary}
                        onChange={handlePostChange}
                        options={prompts.map((theme) => ({
                            label: theme.name,
                            value: theme.id,
                        }))}
                        renderOption={({ option, ...restProps }) => (
                            <CustomSelectOption
                                {...restProps}
                                key={option.value}
                            />
                        )}
                    />
                </FormItem> */}
                <FormItem
                    top={
                        <span className="inputTitle">
                            <span>Промпт</span>
                            <Button
                                before={<Icon20BookSpreadOutline />}
                                mode="secondary"
                                size='s'
                                onClick={() => {
                                    Modal.alert({
                                        title: 'Библиотека шаблонов',
                                        content: (
                                            <>
                                                <FormItem className="postStyle" top="Тип поста">
                                                    <SegmentedControl
                                                        size="m"
                                                        name="style-type"
                                                        defaultValue={styleType}
                                                        onChange={handleStyleChange}
                                                        options={[
                                                            {
                                                                label: 'Подводка',
                                                                value: 'lead',
                                                            },
                                                            {
                                                                label: 'Самостоятельный',
                                                                value: 'post',
                                                            }
                                                        ]}
                                                    />
                                                </FormItem>
                                                {postStyles
                                                    .map((postStyle) => (
                                                        <Card key={postStyle.id} className={`styleElement_${postStyle.typeValue}`}>
                                                            <Banner
                                                                className="groupItem"
                                                                before={
                                                                    <Avatar
                                                                        className="groupImage"
                                                                        size={50}
                                                                        initials={postStyle.icon}
                                                                    />
                                                                }
                                                                header={postStyle.label}
                                                                subheader={`${postStyle.type}`}
                                                                asideMode="expand"
                                                                // Uncomment and add your own click handler
                                                                onClick={() => {
                                                                    Modal.clear();
                                                                    handlePostChange(postStyle);
                                                                }}
                                                            />
                                                        </Card>
                                                    ))}
                                            </>
                                        ),
                                        closeOnMaskClick: true,
                                        showCloseButton: true,
                                        onClose: closeModalStyles
                                    })
                                }}
                            >
                                Библиотека шаблонов
                            </Button>
                        </span>
                    }
                >
                    <Textarea
                        value={prompt_input}
                        onChange={handlePromptChange} // Изменено на использование handleInputChange
                        className="gtpPrompt"
                        placeholder="Введите промпт для ChatGPT" />
                </FormItem>
                <FormItem
                    top={
                        <span className="inputTitle">
                            <span>✍️ Подпись</span>
                            <span className="helpModal"
                                onClick={() => {
                                    Modal.alert({
                                        title: 'Подпись',
                                        content: 'В поле «Подпись» вы можете вставить информацию, которая будет в конце каждого вашего сгенерированного поста. Например, вы можете вставить там призыв подписаться на ваш ресурс или оставить ссылку.',
                                        closeOnMaskClick: true,
                                        showCloseButton: true
                                    })
                                }}
                            >
                                {<Icon20HelpOutline />}
                            </span>
                        </span>
                    }
                >
                    {/*<Textarea value={sign} onChange={handleSignChange} placeholder="Введите подпись" />*/}
                    {isModalVisible && (
                        <Modal
                            title="Введите URL"
                            visible={isModalVisible}
                            closeOnMaskClick
                            showCloseButton
                            closeOnAction
                            onClose={() => {
                                setIsModalVisible(false)
                            }}
                            content={
                                <div className="url-modal">
                                    <Input
                                        ref={inputRef}
                                        placeholder='Введите URL здесь'
                                        value={url}
                                        onChange={(value) => setUrl(value)}
                                    />
                                    <Button
                                        size="l"
                                        appearance="positive"
                                        stretched
                                        onClick={handleOk}
                                    >
                                        Подтвердить
                                    </Button>
                                </div>
                            }
                        >
                        </Modal>
                    )}
                    <>
                        <div className="sign-buttons">
                            <IconButton
                                className={`format-button sign-button ${isBold ? 'active' : ''}`}
                                onClick={(e) => { e.preventDefault(); toggleStyle('bold'); }}>
                                <Icon20TextBoldOutline />
                            </IconButton>
                            <IconButton
                                className={`format-button sign-button ${isItalic ? 'active' : ''}`}
                                onClick={(e) => { e.preventDefault(); toggleStyle('italic'); }}>
                                <Icon20TextItalicOutline />
                            </IconButton>
                            <IconButton
                                className={`format-button sign-button ${isLink ? 'active' : ''}`}
                                onClick={isLink ? removeLink : showModal}>
                                <Icon20Chain />
                            </IconButton>
                        </div>
                    </>
                    <div
                        className="sign-editor"
                        contentEditable
                        ref={textRef}
                        onInput={handleTextChange}
                        onPaste={handlePaste}
                        onFocus={setFocusAndStyle}
                        onBlur={saveSelection}
                        data-placeholder="Введите подпись"
                    />
                </FormItem>
                <Button
                    style={{ marginTop: '10px' }}
                    before={<Icon28RobotOutline />}
                    size='m'
                    stretched={true}
                    loading={loading}
                    onClick={gptTestDrive}
                    disabled={!(prompt_input.length > 0 && s_tags.length > 0)}
                >
                    Тест-драйв
                </Button>
            </FormItem>
            <FormItem
                htmlFor="list"
                top={
                    <span className="inputTitle">
                        <span>🕒 Время постинга</span>
                        <span className="helpModal"
                            onClick={() => {
                                Modal.alert({
                                    title: 'Время постинга',
                                    content: 'Поле «Время постинга» предназначено для указания времени публикаций. Вы можете задать любое количество таймеров, указывающих точные моменты времени, когда сообщения будут автоматически опубликованы.\n' +
                                        '\n' +
                                        'После настройки времени постинга система будет автоматически публиковать сообщения в указанные вами моменты времени, что позволит вам управлять регулярными публикациями',
                                    closeOnMaskClick: true,
                                    showCloseButton: true
                                })
                            }}
                        >
                            {<Icon20HelpOutline />}
                        </span>
                        <Picker
                            cancelText="Отменить"
                            confirmText="Добавить"
                            mouseWheel={true}
                            columns={basicColumns}
                            visible={timeVisible}
                            onClose={() => {
                                setTimeVisible(false)
                            }}
                            onConfirm={v => {
                                // Объединяем элементы массива в одну строку с помощью join
                                const combinedString = v.join(''); // Объединяем элементы в строку
                                const resultArray = [combinedString]; // Создаем новый массив с этой строкой
                                console.log('Оригинал:', resultArray);

                                const adjustTimeWithShift = (timeArray, shift) => {
                                    // Инвертируем знак shift
                                    const adjustedShift = -shift;

                                    return timeArray.map(timeString => {
                                        const [hours, minutes] = timeString.split(':').map(Number);

                                        // Вычисляем новые часы с учетом инверсии shift
                                        const newHours = (hours + adjustedShift + 24) % 24;

                                        return `${String(newHours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
                                    });
                                };

                                const updateAdjustedTags = adjustTimeWithShift(resultArray, shift);

                                console.log('Изменённый:', updateAdjustedTags);

                                const finalArray = [...t_tags, ...updateAdjustedTags]; // Объединяем массивы
                                t_handleTagsChange(finalArray); // Передаем массив в функцию
                            }}
                        />
                    </span>
                }
            >
                <div className={`groupInput timer`}>
                    <FormItem
                        top="Часовой пояс"
                        htmlFor="select-id"
                        bottom="Посты будут публиковаться в соответствии с выбранным часовым поясом. По умолчанию выбрано московское время"
                    >
                        <Select
                            id="select-id"
                            placeholder="Не выбран"
                            value={shift}
                            options={timeZones.map((zone) => ({
                                label: zone.gmt,
                                value: zone.shift
                            }))}
                            onChange={handleZoneChange}
                            renderOption={({ option, ...restProps }) => (
                                <CustomSelectOption
                                    {...restProps}
                                    key={option.value}
                                />
                            )}
                        />
                    </FormItem>
                    <FormItem top="Таймеры">
                        <TagsInput
                            id="list"
                            ref={t_inputRef}
                            value={adjustedTags}
                            onChange={t_handleTagsChange}
                            addOnBlur={true}
                            readOnly
                            // pasteSplit={handlePasteSplit}
                            validationRegex="/^(?:[01]\d|2[0-3]):[0-5]\d$/"
                            inputProps={{
                                inputMode: 'numeric',
                                value: t_currentTag,
                                placeholder: t_tags.length > 0 ? "" : "Добавьте таймеры",
                                onChange: t_handleTagInputChange,
                                onInput: handleNumericInput // добавляем обработчик для замены нецифровых символов на 0
                            }}
                            // addOnPaste
                            renderTag={renderTimeTag}
                        />
                        <Button
                            style={{ marginTop: '10px' }}
                            onClick={() => {
                                setTimeVisible(true)
                            }}
                            size="m"
                            appearance="accent"
                            mode="secondary"
                            stretched
                            before={<Icon16ClockOutline />}
                        >
                            Добавить таймер
                        </Button>
                    </FormItem>
                </div>
                <span className='days'>
                    {dayLabels.map(([day, label]) => (
                        <Checkbox
                            key={day}
                            checked={days.includes(day)}
                            onChange={() => handleCheckboxChange(day)}
                        >{label}
                        </Checkbox>
                    ))}
                </span>
            </FormItem>
            <Collapse style={{ marginBottom: "10vh" }}>
                <Collapse.Panel forceRender="true" key='1' title='⚙️ Дополнительные возможности'>
                    <FormItem
                        htmlFor="list"
                        top={
                            <span className="inputTitle">
                                <span>🏷 Ключевые слова</span>
                                <span className="helpModal"
                                    onClick={() => {
                                        Modal.alert({
                                            title: 'Ключевые слова',
                                            content: 'Поле «Ключевые слова» предназначено для ввода слов или фраз, которые будут использоваться для фильтрации новостей из источников. После ввода ключевых слов, система будет анализировать заголовки новостей из выбранных источников и отображать только те новости, которые содержат указанные ключевые слова.\n' +
                                                '\n' +
                                                'Примеры ключевых слов могут включать:\n' +
                                                '\n' +
                                                '1. Финансы: "биржа", "акции", "фондовый рынок"\n' +
                                                '2. Спорт: "футбол", "теннис", "баскетбол"\n' +
                                                '3. Политика: "парламент", "президент", "законодательство"\n' +
                                                '4. Технологии: "искусственный интеллект", "блокчейн", "криптовалюта"\n' +
                                                '\n' +
                                                'Вы можете указывать одно или несколько ключевых слов разделенных запятой или пробелом. Например: "футбол, теннис, баскетбол" или "инвестиции акции".\n' +
                                                '\n' +
                                                'После введения ключевых слов, система будет фильтровать новости из выбранных источников и отображать только те новости, которые содержат хотя бы одно из введенных ключевых слов. Это позволит вам получать только информацию, которая соответствует вашим интересам и предпочтениям.',
                                            closeOnMaskClick: true,
                                            showCloseButton: true
                                        })
                                    }}
                                >
                                    {<Icon20HelpOutline />}
                                </span>
                            </span>
                        }
                    >
                        <div className={`groupInput keywords`}>
                            <TagsInput
                                id="list"
                                ref={k_inputRef}
                                value={k_tags}
                                onChange={k_handleTagsChange}
                                addOnBlur={true}
                                pasteSplit={handlePasteSplit}
                                inputProps={{
                                    value: k_currentTag,
                                    placeholder: k_tags.length > 0 ? "" : "Введите ключевые слова",
                                    onChange: k_handleTagInputChange,
                                }}
                                addOnPaste
                            />
                        </div>
                    </FormItem>
                    <FormItem
                        htmlFor="list"
                        top={
                            <span className="inputTitle">
                                <span>🛑 Стоп-темы</span>
                                <span className="helpModal"
                                    onClick={() => {
                                        Modal.alert({
                                            title: 'Стоп-темы',
                                            content: 'Поле «Стоп-темы» предназначено для ввода слов или фраз, которые будут использоваться для фильтрации найденных статей по ключевым словам или без них.\n' +
                                                '\n' +
                                                'Примеры стоп-тем могут включать:\n' +
                                                '\n' +
                                                '1. Смерть: "убийство", "погиб", "утонула"\n' +
                                                '\n' +
                                                '2. Личности: "Путин", "Кадыров", "Байден"\n' +
                                                '\n' +
                                                '3. Политика: "парламент", "президент", "законодательство"\n' +
                                                '\n' +
                                                '4. Спорт: "футбол", "матч", "хоккеист"\n' +
                                                '\n' +
                                                'Вы можете указывать одно или несколько стоп-тем, разделенных запятой или пробелом. Например: "Путин, футбол, убийство" или "несчастный случай".\n' +
                                                '\n' +
                                                'После ввода стоп-тем система будет анализировать заголовки найденных новостей и отображать только те новости, в которых нет слов/фраз из этого поля.',
                                            closeOnMaskClick: true,
                                            showCloseButton: true
                                        })
                                    }}
                                >
                                    {<Icon20HelpOutline />}
                                </span>
                            </span>
                        }
                    >
                        <div className={`groupInput negative`}>
                            <TagsInput
                                id="list"
                                ref={n_inputRef}
                                value={n_tags}
                                onChange={n_handleTagsChange}
                                addOnBlur={true}
                                pasteSplit={handlePasteSplit}
                                inputProps={{
                                    value: n_currentTag,
                                    placeholder: n_tags.length > 0 ? "" : "Введите стоп-темы",
                                    onChange: n_handleTagInputChange,
                                }}
                                addOnPaste
                            />
                        </div>
                    </FormItem>
                    <FormItem
                        style={{ display: postSource ? 'none' : 'block' }}
                        top={
                            <span className="inputTitle">
                                <span>💡 Креативность</span>
                                <span className="helpModal"
                                    onClick={() => {
                                        Modal.alert({
                                            title: 'Креативность',
                                            content: 'Ползунок «Креативность» позволяет вам регулировать уровень креативности или неожиданности ответов модели ChatGPT. Чем выше значение на ползунке, тем более неожиданными и оригинальными могут быть ответы модели.\n' +
                                                '\n' +
                                                'На ползунке «Креативность» можно выбрать значение от низкого до высокого, чтобы контролировать уровень вариативности ответов. Однако, важно помнить, что более высокие значения могут привести к менее предсказуемым результатам, и некоторые ответы могут быть менее связанными с вопросом или заданием.\n' +
                                                '\n' +
                                                'Вы можете использовать ползунок «Креативность» для того, чтобы попробовать различные уровни креативности и найти баланс между ожидаемыми и оригинальными ответами модели. Подберите уровень креативности, который наилучшим образом соответствует вашим потребностям и предпочтениям.',
                                            closeOnMaskClick: true,
                                            showCloseButton: true
                                        })
                                    }}
                                >
                                    {<Icon20HelpOutline />}
                                </span>
                            </span>
                        }
                    >
                        <span
                            className="tempButtons"
                            style={{ display: "flex", justifyContent: "space-between", paddingBottom: "8px", paddingTop: "10px" }}
                        >
                            <button onClick={decreaseValueGpt}>−</button>
                            <button onClick={increaseValueGpt}>+</button>
                        </span>
                        <Slider
                            step={0.1}
                            min={0.4}
                            max={1}
                            aria-labelledby="with-step"
                            value={gptTemp}
                            onChange={handleTempChange}
                        />
                    </FormItem>
                    <FormItem
                        htmlFor="list"
                        top={
                            <span className="inputTitle">
                                <span>🌐 Источник</span>
                                <span className="helpModal"
                                    onClick={() => {
                                        Modal.alert({
                                            title: 'Источник',
                                            content: 'При активации «Добавить в посты ссылку на исходный текст» в посте будет указан URL исходной статьи нативным методом для VK',
                                            closeOnMaskClick: true,
                                            showCloseButton: true
                                        })
                                    }}
                                >
                                    {<Icon20HelpOutline />}
                                </span>
                            </span>
                        }
                    >
                        <div className={`postSource`}>
                            <Checkbox checked={postOriginal} onChange={handlePostOriginal}>Добавить в пост ссылку на исходный текст</Checkbox>
                        </div>
                    </FormItem>
                    <FormItem
                        htmlFor="list"
                        top={
                            <span className="inputTitle">
                                <span>🗒️ Исходный текст</span>
                                <span className="helpModal"
                                    onClick={() => {
                                        Modal.alert({
                                            title: 'Перенос текста',
                                            content: 'При активации «Переносить исходный текст из Telegram-каналов и пабликов/групп VK» текст из найденной новости/статьи будет перенесён без каких-либо изменений, исправлений и дополнений со стороны ChatGPT.\n' +
                                                '\n' +
                                                'ВАЖНО: если данная функция активирована, то при сборе новостей будут проигнорированы все источники, кроме Telegram-каналов и пабликов/групп VK. Так же не поддерживаются Premium Emoji из Telegram-каналов, они будут сконвертированы в обычные',
                                            closeOnMaskClick: true,
                                            showCloseButton: true
                                        })
                                    }}
                                >
                                    {<Icon20HelpOutline />}
                                </span>
                            </span>
                        }
                    >
                        <div className={`postSource`}>
                            <Checkbox checked={postSource} onChange={handlePostSource}>Переносить исходный текст из Telegram-каналов и пабликов/групп VK</Checkbox>
                        </div>
                    </FormItem>
                    <FormItem
                        htmlFor="list"
                        top={
                            <span className="inputTitle">
                                <span>⚡ Принудительный постинг</span>
                                <span className="helpModal"
                                    onClick={() => {
                                        Modal.alert({
                                            title: 'Принудительный постинг',
                                            content: 'При активации «Постить подходящую новость при отсутствии фактуры в первоисточнике» сервис будет брать последнюю статью из источников, в случае если по найденным ключевым словам ничего не найдено или все новости по ключевым словам уже были запощены',
                                            closeOnMaskClick: true,
                                            showCloseButton: true
                                        })
                                    }}
                                >
                                    {<Icon20HelpOutline />}
                                </span>
                            </span>
                        }
                    >
                        <div className={`postForce`}>
                            <Checkbox checked={postForce} onChange={handlePostForce}>Постить подходящую новость при отсутствии фактуры в первоисточнике</Checkbox>
                        </div>
                    </FormItem>
                    <FormItem
                        htmlFor="list"
                        top={
                            <span className="inputTitle">
                                <span>🖼 Визуал</span>
                                <span className="helpModal"
                                    onClick={() => {
                                        Modal.alert({
                                            title: 'Визуал',
                                            content: 'При активации «Отключить картинки/видео» пост не будет содержать в себе картинку/картинки или видео, даже если они есть в найденной новости/посте',
                                            closeOnMaskClick: true,
                                            showCloseButton: true
                                        })
                                    }}
                                >
                                    {<Icon20HelpOutline />}
                                </span>
                            </span>
                        }
                    >
                        <div className={`postMedia`}>
                            <Checkbox checked={postMedia} onChange={handlePostMedia}>Отключить картинки/видео</Checkbox>
                        </div>
                    </FormItem>
                </Collapse.Panel>
            </Collapse>
            <div className="saveButtonWrapper">
                <Button
                    // before={<Icon16Stars />}
                    tyle={{ flexGrow: '0' }}
                    size="l"
                    loading={saveState}
                    stretched
                    appearance="positive"
                    onClick={() => {
                        sendDataTwo(tabs, userInfo, selectedGroup);
                    }}
                    className="saveButton"
                >
                    Сохранить
                </Button>
            </div>
        </div>
        </>
    );
};

export default ChannelPage;